import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
/**
 * Renders an ingredient that is not a conflict, skip, replacement or customization.
 * Optionally appending a comma if it isn't the last item in the list.
 *
 * @param {string} ingredientName - The name of the ingredient to display.
 * @param {boolean} shouldAppendComma - Flag indicating whether a comma should be appended after the ingredient name. If `true`, no comma is appended; if `false`, a comma is appended.
 */
export const RegularIngredient = ({ ingredientName, shouldAppendComma }) => {
    if (ingredientName === "" || ingredientName === undefined)
        return _jsx(_Fragment, {});
    return (_jsx(Typography, Object.assign({ variant: "body1", component: "span" }, { children: ingredientName + (shouldAppendComma ? "" : ", ") })));
};
